__turbopack_context__.v({
  "campaignIcon": "WhereToGoDropdownContent-module__YgUcnW__campaignIcon",
  "container": "WhereToGoDropdownContent-module__YgUcnW__container",
  "spring-rotation": "WhereToGoDropdownContent-module__YgUcnW__spring-rotation",
  "tabContent": "WhereToGoDropdownContent-module__YgUcnW__tabContent",
  "tabsContainer": "WhereToGoDropdownContent-module__YgUcnW__tabsContainer",
  "tabsContentsContainer": "WhereToGoDropdownContent-module__YgUcnW__tabsContentsContainer",
});
